import { duplicateBlock } from './create'
import { readBlockDuplication } from './read'

export const blockDuplication = {
  create: duplicateBlock,
  read: readBlockDuplication,
}
